/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { CountryStates } from '@core/models/google-maps.model';
import { createAction, props } from '@ngrx/store';

/**
 * Load USA States
 */
export const loadUsaStates = createAction('[Utils/API] Load UsaStates');
export const loadUsaStatesSuccess = createAction(
  '[Utils/API] Load UsaStates Success',
  props<{ data: CountryStates[] }>()
);
export const loadUsaStatesFailure = createAction('[Utils/API] Load UsaStates Failure', props<{ errorMessage: any }>());
